import $http from '../services/AxiosInstance';
import { IChubbnetPingResponse, IChubbnetStatus } from '../types/chubbnet.type';

class ChubbnetRepository {
  async getChubbnetStatus(): Promise<IChubbnetStatus> {
    try {
      const { status, data } = await $http.get<IChubbnetPingResponse>('/chubb/ping');
      return {
        isOn: status === 200,
        renewalDays: data?.renewalDays,
        renewalMessage: data?.renewalMessage,
      };
    } catch (errors: any) {
      // El interceptor de axios rechaza con el body de la respuesta
      return {
        isOn: false,
        renewalDays: errors?.renewalDays,
        renewalMessage: errors?.renewalMessage,
      };
    }
  }
}

export default ChubbnetRepository;
